export default function FluidCalculationForChildrenComponent() {
  return <></>;
}
